<div class="modal-lg buying-windows-details">
  <div class="modal-header state">
    <h1
      class="modal-title text-truncate full-width text-transformation-none calendar"
      id="modal-label"
    >
      Buying Window Calendar
    </h1>
    <button
      type="button"
      (click)="close()"
      class="close btn btn-icon"
      aria-label="Close"
    >
      <span class="fal fa-times" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <div class="years--container">
        @for (year of years; track $index) {
          <button
            class="btn year_button"
            [ngClass]="{ selected: year === selectedYear }"
            (click)="onYearChange(year)"
          >
            {{ year }}
          </button>
        }
      </div>
      <div class="selected--year mt-3">
        {{ selectedYear }}
      </div>

      <div class="buying-window--list mt-3">
        @for (buyingWindow of selectedBuyingWindows; track buyingWindow) {
          <app-buying-window-item
            [orderWindow]="buyingWindow"
            (onNavigate)="close()"
          ></app-buying-window-item>
        }
      </div>
    </div>
  </div>
</div>
